/**
 * UINT64 2^64-1(0~9223_37203_68547_75807)범위의 랜덤값을 구하기 위한 함수
 * Javascript Number.MAX_SAFE_INTEGER(9_00719_92547_40991)
 */
export const randomUInt64Number = () => {
  return `${Math.floor(Math.random() * 9223) + 1}${String(
    Math.floor(Math.random() * 999999999999999)
  ).padStart(15, "0")}`;
};

// 86f9a11a-dc4a-41df-9005-9debf0510f5e
export const convertUUIDToUint64 = (input: string) => {
  return `${parseInt(input.replace(/-/g, "").substring(0, 13), 16)}`;
};
